var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-vibrate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.71,
    y: 24.38,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.71,
    y: 18.28,
    width: 1.53,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.71,
    y: 12.19,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.71,
    y: 6.09,
    width: 1.53,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 22.85,
    width: 1.52,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 19.81,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 16.76,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 13.71,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 10.66,
    width: 1.52,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.19,
    y: 7.62,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.66,
    y: 21.33,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.66,
    y: 15.23,
    width: 1.53,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.66,
    y: 9.14,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38,32H23.62V30.47h1.52V1.52H23.62V0H8.38V1.52H6.85V30.47H8.38ZM16,1.52h3.04V3.04H16Zm-3.05,0h1.52V3.04H12.95ZM8.38,3.04h3.05V4.57h9.14V3.04h3.05V28.95H8.38Z",
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.57,
    y: 19.81,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.04,
    y: 15.23,
    width: 1.53,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.04,
    y: 12.19,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.52,
    y: 21.33,
    width: 3.05,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.52,
    y: 13.71,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.47,
    y: 19.81,
    width: 3.05,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.95,
    y: 13.71,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.43,
    y: 21.33,
    width: 3.04,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.43,
    y: 15.23,
    width: 1.52,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.43,
    y: 12.19,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 19.81,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.81,
    y: 21.33,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.81,
    y: 15.23,
    width: 1.52,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.81,
    y: 9.14,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 22.85,
    width: 1.53,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 19.81,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 16.76,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 13.71,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 10.66,
    width: 1.53,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.28,
    y: 7.62,
    width: 1.53,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.76,
    y: 24.38,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.76,
    y: 18.28,
    width: 1.52,
    height: 1.53,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.76,
    y: 12.19,
    width: 1.52,
    height: 1.52,
    fill: "#08bdba"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.76,
    y: 6.09,
    width: 1.52,
    height: 1.53,
    fill: "#08bdba"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.34e7c11ac4f80f26dbffc482cc92079a.svg";
export { ForwardRef as ReactComponent };